import { Typography } from '@tempmee/react';
import { SolidExclamationCircleIcon } from '@tempmee/react-icons';
import { colors } from '@tempmee/tailwind';
import { forwardRef } from 'react';

export interface IAuthErrorBannerProps {
  visible: boolean;
  message?: string;
  /** Prefix rendered before the message. Pass an empty string to omit. @default 'Oops!' */
  prefix?: string;
}

const DEFAULT_MESSAGE = 'It looks like a few required fields were left empty.';
const DEFAULT_PREFIX = 'Oops!';

export const AuthErrorBanner = forwardRef<HTMLDivElement, IAuthErrorBannerProps>(
  ({ visible, message = DEFAULT_MESSAGE, prefix = DEFAULT_PREFIX }, ref) => {
    if (!visible) return null;
    const content = prefix ? `${prefix} ${message}` : message;
    return (
      <div
        ref={ref}
        role="alert"
        aria-live="polite"
        data-testid="auth-error-banner"
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 6,
          padding: '4px 2px',
        }}
      >
        <SolidExclamationCircleIcon
          size={24}
          color={colors.error[500]}
          style={{ flexShrink: 0 }}
        />
        <Typography size="body_large" color={colors.error[500]}>
          {content}
        </Typography>
      </div>
    );
  },
);

AuthErrorBanner.displayName = 'AuthErrorBanner';
